module.exports = __webpack_public_path__ + "assets/cover_5_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_5_old.jpg
 ** module id = 210
 ** module chunks = 1
 **/